module.exports = __webpack_public_path__ + "media/bootstrap-icons/nut-fill-fdeaf135.svg";